import React, { useContext } from "react";
import classes from "./ChooseCard.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../../App";

const ChooseCard = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <div className={classes.outer}>
      <img
        src={data?.image}
        alt="who-can-choose-us"
      />
      <h1>{data?.title}</h1>
      {/* <div className={`${classes.underLine} bg-secondary-300`}></div> */}
      <p>{data?.description}</p>
    </div>
  );
};

export default ChooseCard;
